import React from 'react';

import { DefaultLoader } from './default-loader';

interface CashierLoaderProps {
  disableLoader: boolean;
}

export const CashierLoader: React.FC<CashierLoaderProps> = ({
  disableLoader
}) => {

  if (disableLoader) return null;

  return <DefaultLoader />;
};
